let URLPath = {
  SECURITY: {
    LOGIN: {
      URI: "auth/login",
      METHOD: "POST"
    },
    LOGOUT: {
      URI: "auth/logout",
      METHOD: "POST"
    },
    ME: {
      URI: "users/me",
      METHOD: "GET"
    },
    REFRESH: {
      URI: "auth/refresh_token",
      METHOD: "POST"
    }
  },
  USER: {
    LIST: "/users",
    GET: {
      URI: "/users/{USER_ID}",
      METHOD: "GET"
    },
    CREATE: {
      URI: "/users",
      METHOD: "POST"
    },
    EDIT: {
      URI: "/users/{USER_ID}",
      METHOD: "PUT"
    },
    UNIQUE_USERNAME: {
      URI: "/users/username/exists",
      METHOD: "POST"
    },
    APPLICATION: {
      URI: "/users/{USER_ID}/applications",
      METHOD: "POST"
    },
    PROVISION: {
      URI: "/users/{USER_ID}/provisions",
      METHOD: "POST"
    },
    PASSWORD: {
      URI: "/users/change-password",
      METHOD: "PUT"
    },
    SETTINGS: {
      URI: "/users/{USER_ID}/settings",
      METHOD: "PUT"
    }
  },
  APPLICATION: {
    LIST: "/applications",
    CREATE: {
      URI: "/applications",
      METHOD: "POST"
    },
    EDIT: {
      URI: "/applications/{APPLICATION_ID}",
      METHOD: "PUT"
    },
    DELETE: {
      URI: "/applications/{APPLICATION_ID}",
      METHOD: "DELETE"
    },
    SECRET: {
      URI: "/applications/{APPLICATION_ID}/secret",
      METHOD: "PUT"
    },
    UNIQUE_NAME: {
      URI: "/applications/name/exists",
      METHOD: "POST"
    }
  },
  PROVISION: {
    LIST: "/provisions",
    DOWNLOAD: {
      URI: "/provisions/export",
      METHOD: "GET"
    },
  },
  PROFILE: {
    EDIT: {
      URI: "/profiles",
      METHOD: "PUT"
    }
  },
  JOBS: {
    EDIT: {
      URI: "/jobs/{JOBS_ID}",
      METHOD: "PUT"
    },
    SWITCH: {
      URI: "/jobs/{JOBS_ID}/switch",
      METHOD: "PUT"
    }
  },
  PAYMENT: {
    LIST: "/payments",
    DOWNLOAD: {
      URI: "/payments/export",
      METHOD: "GET",
      PROCESS: {
        URI: "/payments-process/print",
        METHOD: "POST",
      }
    },
    STATISTIC: "/payments/statistics",
    CHANGE_STATUS: {
      URI: "/payments/{PAYMENT_ID}/change-status",
      METHOD: "PUT",
    }
  },
  OPERATION: {
    LIST: "/operations",
  },
  TESTER: {
    PAYMENT: {
      INIT: {
        URI: "/payments-process/init",
        METHOD: "POST"
      },
      RUN: {
        URI: "/payments-process/run",
        METHOD: "POST"
      },
      CHECK: {
        URI: "/payments-process/check",
        METHOD: "POST"
      }
    },
    TRANSFER: {
      INIT: {
        URI: "/transfers-process/init",
        METHOD: "POST"
      }
    }
  },
  TRANSFER: {
    LIST: "/transfers",
    PROCESS: {
      INIT: {
        URI: "/transfers-process/init",
        METHOD: "POST"
      }
    },
    DOWNLOAD: {
      URI: "/transfers/export",
      METHOD: "GET"
    },
    APPROVE: {
      URI: "/transfers/approve",
      METHOD: "POST"
    },
    CANCEL: {
      URI: "/transfers/cancel",
      METHOD: "POST"
    },
    STATISTIC: "/transfers/statistics"
  },
};

export default URLPath;
